// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__wJf9DJVV","error":"Captcha_error__e4zNraco"};